import { TabContent } from "@/components/common/PageLayout";
import { PolicyEndorsementsSection } from "./PolicyEndorsementsSection";
import type { DrawerContent } from "../PolicyShow";

interface PolicyEndorsementsTabProps {
  drawerExpanded: boolean;
  setDrawerContent: (content: DrawerContent) => void;
  activeEndorsementId: string | null;
}

/**
 * Dedicated tab for endorsement management on the Policy show page.
 * Renders the categorized endorsement list directly — no accordion wrapper needed
 * since the tab itself provides the visual boundary.
 */
export const PolicyEndorsementsTab = ({
  drawerExpanded,
  setDrawerContent,
  activeEndorsementId,
}: PolicyEndorsementsTabProps) => {
  const handleEndorsementSelect = (endorsementId: string) => {
    setDrawerContent({ type: "endorsement", endorsementId });
  };

  const handleAddEndorsement = () => {
    setDrawerContent({ type: "endorsement-create" });
  };

  return (
    <TabContent>
      <PolicyEndorsementsSection
        // TODO: update userCanEdit once we have canAccess set up
        userCanEdit={true}
        onEndorsementSelect={handleEndorsementSelect}
        onAddEndorsement={handleAddEndorsement}
        activeEndorsementId={activeEndorsementId}
        isDrawerOpen={drawerExpanded}
      />
    </TabContent>
  );
};
